export { default } from "./KeyTermPopoutBody";
